import { UploadMenu } from 'articleEditor/components/uploadMenu';
import { UseFloatingMenuReturn } from 'articleEditor/hooks/useFloatingMenu';
import {
  findNodePath,
  focusEditor,
  setNodes,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyImageElement } from 'lib-knowledge-document-structure/plateTypes';
import { useCallback } from 'react';

import { UploadImage, UploadResults } from './uploadImage';

type ImagePickerUploadMenuProps = {
  element: MyImageElement;
  floatingUploadMenu: UseFloatingMenuReturn;
};

export function ImagePickerUploadMenu({
  element,
  floatingUploadMenu,
}: ImagePickerUploadMenuProps): JSX.Element {
  const editor = useMyEditorRef();

  const onUpload = useCallback(
    (results: UploadResults) => {
      const path = findNodePath(editor, element);
      setNodes(
        editor,
        {
          url: results.url,
          filename: results.filename,
          originalWidth: results.width,
          originalHeight: results.height,
        },
        { at: path },
      );

      // Give the DOM a chance to update
      setTimeout(() => {
        floatingUploadMenu.closeFloatingMenu();

        focusEditor(editor, editor.selection!);
      }, 50);
    },
    [editor, element, floatingUploadMenu],
  );

  if (!floatingUploadMenu.showFloatingMenu) return <></>;

  return (
    <UploadMenu
      floatingProps={{ ...floatingUploadMenu.floatingResult, isOpen: true }}
      getFloatingProps={floatingUploadMenu.getFloatingMenuProps}
    >
      <UploadImage onUpload={onUpload} />
    </UploadMenu>
  );
}

// TODO: later when we support url upload
// function Embed() {
//   const [imageUrl, setImageUrl] = useState('');
//   const isValid = isUrl(imageUrl);
//   return (
//     <FlexBox gap="200" padding="400">
//       <InputText
//         placeholder="Image url"
//         value={imageUrl}
//         onChange={(e) => setImageUrl(e.target.value)}
//       />
//       <Button className={uploadMenuStyles['embedButton']} disabled={!isValid}>
//         Embed
//       </Button>
//     </FlexBox>
//   );
// }
